import { GroupQuery_group } from "@/graphql/generatedTypes/GroupQuery";

export const NULL_GROUP: GroupQuery_group = {
  __typename: "Group",
  id: "",
  address1: null,
  address2: null,
  city: null,
  state: null,
  zip: null,
  isPrivate: false,
  isOneOnOne: false,
  maxParticipants: 0,
  trainer: null,
  participants: [],
  sessions: [],
  isFull: false,
  virtual: false
};
